export const CONSTANTS = {
  CHART: {
    TYPE: 'scatter',
    SERIES_LINE_WIDTH: 32,
  },
  COLOR: {
    BLUE: '#0058FF',
    GRAY: '#CFDFFF',
  },
  DRAWING: {
    FONT_SIZE: '20px',
    FONT_WEIGHT: '500',
    TEXT_ALIGN: 'center',
    PLOT_LINE_COLOR: '#AEAEAE',
    FOCUS_TEXT_COLOR: '#C9D5FF',
    FOCUS_AREA_COLOR: '#ECF0FE',
    MAINTAIN_TEXT_COLOR: '#EEEEEE',
  },
  AXIS: {
    PADDING_X: 0.05,
    LABEL_FONT_SIZE: '8px',
    LABEL_FONT_WEIGHT: '500',
    TICK_AMOUNT_Y: 4,
    TICK_LENGHT_DEFAULT_X: 0,
    TICK_LENGHT_X: 10,
    START_ON_TICK: true,
    END_ON_TICK: true,
    TICK_INTERVAL_X: 2.5,
    START_ON_TICK_X: false,
    END_ON_TICK_X: false,
    GRID_LINE_COLOR: '#EEEEEE',
  },
  MARKER: {
    SYMBOL: 'circle',
    RADIUS: 16,
    ENABLED: true,
  },
  DATA_LABEL: {
    ENABLED: true,
    OVERLAP: true,
    TEXT_OUTLINE: {
      NONE: 'none',
      BLUE: '2px #0058FF',
    },
    POINT: {
      TEXT_COLOR: '#FFFFFF',
      FONT_WEIGHT: 'bold',
    },
    DISPLAY_LABEL: {
      SHAPE: 'callout',
      SHADOW: true,
      Y: -16,
      FONT_WEIGHT: 'normal',
      TEXT_ALIGN: 'left',
    },
  },
  GRADIENT: {
    SERIES_LINEAR: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1,
    },
    COLOR_STOP_1: 0,
    COLOR_STOP_2: 0.275,
    COLOR_STOP_3: 0.61,
    COLOR_STOP_4: 1,
  },
};
